import { client } from "api";
import { Company } from "models/Company";

export type GetCompanyByIdRequest = {
  companyId: string;
};

export type GetCompanyByIdResponse = Company;

export const getCompanyById = (request: GetCompanyByIdRequest): Promise<GetCompanyByIdResponse> =>
  client
    .get<GetCompanyByIdResponse>(`/company/${request.companyId}`)
    .then((res) => ({ ...res.data, id: request.companyId }));
